<template>
  <component
    :is="tagName"
    :role="role"
    class="oct-menu-item"
    :class="{
      'oct-menu-item--disabled': disabled
    }"
  >
    <!-- Leading Icon -->
    <span
      v-if="$slots.leadingIcon"
      class="oct-menu-item__leading-icon"
    >
      <slot name="leadingIcon" />
    </span>

    <!-- Text -->
    <span class="oct-menu-item__text">
      <slot />
    </span>
  </component>
</template>

<script>
export default {
  name: 'OctMenuItem',
  props: {
    /** Tag name */
    tagName: {
      type: String,
      default: 'li'
    },
    /** Native role attribute */
    role: {
      type: [String, null],
      default: 'menuitem'
    },
    /** Whether the item is disabled */
    disabled: {
      type: Boolean,
      default: false
    },
  },
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-menu-item {
  text-align: left;
  display: flex;
  align-items: center;
  gap: oct-rem(8);
  padding: oct-rem(8) 0;
  cursor: pointer;
  overflow: hidden;

  &--disabled {
    color: $oct-theme--neutral-20;
    pointer-events: none;
  }

  &[role="separator"] {
    margin: oct-rem(8) 0;
    padding: 0;
    height: oct-rem(1);
    background-color: $oct-theme--neutral-20;
    border: none;
  }
}

.oct-menu-item__leading-icon {
  flex: 0 0 auto;
  width: oct-rem(28);
  height: oct-rem(28);
  margin: oct-rem(-6);
}

.oct-menu-item__text {
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
